import { useAuth } from "../../../context";
import { useMutation, useQuery } from "react-query";
import { SupplierPhysicalRiskQuestionnaire } from "../../../api/supplier-physical-risk-questionnaire";

export const supplierPhysicalRiskQuestionnaireKeys = {
  all: () => ["supplierPhysicalRiskQuestionnaire"],
  active: () => [...supplierPhysicalRiskQuestionnaireKeys.all(), "active"],
  supplierPhysicalRiskQuestionnaireById: () => ["supplierPhysicalRiskQuestionnaireById"]
};

export function useGetSupplierPhysicalRiskQuestionnaireById(id, config) {
  const { callApi } = useAuth();
  return useQuery([...supplierPhysicalRiskQuestionnaireKeys.supplierPhysicalRiskQuestionnaireById(), id],
    () => callApi(SupplierPhysicalRiskQuestionnaire.getQuestionnaireById, id), config);
}

export function useCreateNewLocation(config) {
  const { callApi } = useAuth();
  return useMutation(({ physicalRiskId, data }) =>
    callApi(SupplierPhysicalRiskQuestionnaire.createNewLocation, { physicalRiskId, data }), config);
}

export function useUpdateLocation(config) {
  const { callApi } = useAuth();
  return useMutation(({ physicalRiskId, locationId, data }) =>
    callApi(SupplierPhysicalRiskQuestionnaire.updateLocation, { physicalRiskId, locationId, data }), config);
}

export function useFinalizeSupplierPhysicalRiskQuestionnaire(config) {
  const { callApi } = useAuth();
  return useMutation(id => callApi(SupplierPhysicalRiskQuestionnaire.finalizePhysicalRiskQuestionnaire, id), config);
}

export function useGetSupplierPhysicalRiskQuestionnaire(id, config) {
  const { callApi } = useAuth();
  return useQuery([id],
    () => callApi(SupplierPhysicalRiskQuestionnaire.getSupplierPhysicalRiskQuestionnaire, id), config);
}